import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom'

import Loader from '@components/shared/loader/loader'
const ShortContactForm = lazy(() => import('../components/contact/short_contact_form'));

document.addEventListener('DOMContentLoaded', () => {
  const elem = document.getElementById('contact-form-body');
  const place = elem.dataset.place || '';
  const titleProvider = elem.closest('[data-form-title]');
  const title = titleProvider?.dataset?.formTitle || undefined;

  ReactDOM.render(
    <Suspense fallback={Loader()}>
      <ShortContactForm place={place} title={title} />
    </Suspense>,
    elem
  );
}, { once: true });